<script setup lang="ts">
import type { PerActionItemRule, PolicyDocumentAction } from '#layers/access';
import type { GlobalCollectionId } from '#layers/data-model';
import { computed } from 'vue';
import { isEmptyFilter } from '#layers/data-model';

interface InputPolicyItemRulesProps {
	collectionId: GlobalCollectionId;
	action: PolicyDocumentAction;
}

defineProps<InputPolicyItemRulesProps>();
const modelValue = defineModel<PerActionItemRule>({ required: true });

const hasConfiguration = computed(() => !isEmptyFilter(modelValue.value?.filter));

const filter = computed({
	get() {
		return modelValue.value?.filter;
	},
	set(value) {
		// Ensure that itemRules are {} instead of { filter: null }
		if (value === null) {
			modelValue.value.filter = undefined;
		}
		else {
			modelValue.value.filter = value;
		}
	},
});
</script>

<template>
	<DFormSeparator
		:label="$t('policy.item_rules.title')"
		:description="$t('policy.item_rules.configuration_description', { action: $t(`policy.action.${action}`).toLowerCase() })"
		:badge="hasConfiguration ? {
			color: 'primary',
			variant: 'soft',
			label: $t('common.configuration_set'),
		} : {
			color: 'neutral',
			variant: 'soft',
			label: $t('common.configuration_not_set') }"
	/>
	<InputFilterBlock v-model="filter" :collection-id clear-filter-display-style="link" />
	<DNotice
		v-if="!hasConfiguration"
		color="info"
		:title="$t('policy.item_rules.no_item_filter_title')"
		:description="$t('policy.item_rules.no_item_filter_description', { action })"
	/>
</template>
